module.exports = __webpack_public_path__ + "static/media/ProcessOverhead.e6eb11fc.svg";